import { PropsWithChildren, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { FormattedMessage } from 'react-intl';

import BackIcon from '@/assets/icons/back.svg';
import ErrorIcon from '@/assets/icons/error.svg';
import ReloadIcon from '@/assets/icons/reload.svg';
import { Typography } from '@/components/ui/typography';

import { Button } from './button';

export function ErrorState() {
  const goBack = () => {
    window.history.back();
  };

  useEffect(() => {
    const handlePopState = () => {
      window.location.reload();
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="mx-auto flex w-[300px] flex-1 flex-col items-center justify-center">
      <img src={ErrorIcon} alt="Error" />
      <Typography variant="body2">
        <FormattedMessage
          defaultMessage="Oops ! Something went wrong."
          description="Short error title in generic error state view"
        />
      </Typography>
      <Typography variant="subtitle1" className="text-center">
        <FormattedMessage
          defaultMessage="We encountered an unexpected error. Please try refreshing the page, or contact support if the problem persists"
          description="Generic error boundary message for failed data loads in Source"
        />
      </Typography>
      <div className="my-4 flex items-center justify-center gap-2">
        <Button variant="secondary" size="sm" onClick={goBack}>
          <img src={BackIcon} alt="Error" />
          <FormattedMessage
            defaultMessage="Back"
            description="Error UI: navigate to previous route"
          />
        </Button>
        <Button variant="secondary" size="sm" onClick={reloadPage}>
          <img src={ReloadIcon} alt="Error" />
          <FormattedMessage
            defaultMessage="Reload"
            description="Error UI: full page refresh to retry"
          />
        </Button>
      </div>
    </div>
  );
}

export function ErrorStateFallback({ children }: PropsWithChildren) {
  return <ErrorBoundary fallback={<ErrorState />}>{children}</ErrorBoundary>;
}
